
import React from "react";
import { Badge } from "@/components/ui/badge";

interface LeadInvestmentBadgeProps {
  investmentRange: string;
}

export const LeadInvestmentBadge = ({ investmentRange }: LeadInvestmentBadgeProps) => {
  if (!investmentRange) return null;
  
  // Simplify display for larger amounts to prevent overflow
  let displayText = investmentRange;
  if (investmentRange.includes("Over $100,000")) {
    displayText = ">$100K";
  } else if (investmentRange.includes("-")) {
    // Format ranges like "$10,000 - $25,000" to "$10K-$25K"
    displayText = investmentRange
      .replace(/\$(\d+),000/g, "$$$1K")
      .replace(" - ", "-");
  }
  
  return (
    <Badge 
      variant="success" 
      className="ml-2 font-normal text-xs bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300 hover:bg-green-100 dark:hover:bg-green-900/30 whitespace-nowrap"
    >
      {displayText}
    </Badge>
  );
};
